import {useLocation} from 'react-router'

import {useSessionUpdatedEventListener} from '@product-web/auth--session/store'
import {useFlags} from '@product-web/flags'
import {useHasAllowedRole} from '@product-web/user'
import {createPersistedState} from '@product-web/web-platform/persisted-state'
import {localStorage} from '@product-web/web-platform/storage/local'
import {ADOPTION_ESSENTIALS_PATHS} from '@product-web-features/help-centre/get-is-adoption-centre-visible'

import {bff} from '../bff-hooks'

export const VISMA_MIGRATION_ADOPTION_PROMPT_PERSISTED_STATE_KEY = 'visma-migration-adoption-prompt'
export const VISMA_MIGRATION_ADOPTION_PROMPT_VIEWED_LOCALSTORAGE_KEY =
    'vismaMigrationAdoptionPromptViewed'

const [usePersistedState, clearPersistedState] = createPersistedState(
    VISMA_MIGRATION_ADOPTION_PROMPT_PERSISTED_STATE_KEY,
    localStorage,
)

const VISMA_MIGRATION_ADOPTION_PATHS = ADOPTION_ESSENTIALS_PATHS.filter(
    (path) => path !== '/reimbursements' && path !== '/invoices',
)

export const useVismaMigrationAdoption = () => {
    const {newVismaEconomicsMigration} = useFlags()
    const shouldShowMigrationFlow = newVismaEconomicsMigration
        ?.split(',')
        .includes('SHOW_MIGRATION_HELPERS')
    const isOwnerOrBookkeeper = useHasAllowedRole([
        'owner',
        'bookkeeper-extended',
        'bookkeeper-basic',
    ])

    const [isVismaMigrationAdoptionPromptViewed, setIsVismaMigrationAdoptionPromptViewed] =
        usePersistedState<boolean>(VISMA_MIGRATION_ADOPTION_PROMPT_VIEWED_LOCALSTORAGE_KEY, false)

    const {data: vismaMigrationAdoptionPromptStatus} =
        bff.adoption.vismaMigrationAdoptionPrompt.getVismaMigrationAdoptionPromptStatus.useQuery(
            undefined,
            {
                enabled: isOwnerOrBookkeeper && !isVismaMigrationAdoptionPromptViewed,
            },
        )

    const location = useLocation()
    const isVisibleLocation = VISMA_MIGRATION_ADOPTION_PATHS.some((p) =>
        location.pathname.startsWith(p),
    )

    useSessionUpdatedEventListener(() => {
        clearPersistedState()
    })

    const shouldShowVismaMigrationAdoptionPrompt =
        !!vismaMigrationAdoptionPromptStatus?.isVisible &&
        isOwnerOrBookkeeper &&
        shouldShowMigrationFlow &&
        isVisibleLocation &&
        !isVismaMigrationAdoptionPromptViewed

    const setVismaMigrationAdoptionPromptViewed = () => {
        setIsVismaMigrationAdoptionPromptViewed(true)
    }

    return {
        shouldShowVismaMigrationAdoptionPrompt,
        setVismaMigrationAdoptionPromptViewed,
        clearPersistedState,
    }
}
